module.exports = __webpack_public_path__ + "img/GY.16956dd4.png";